// client/src/coms/views/canvas_parts/CanvasShapeSettingsPanel.js
import React from 'react';

const SHAPE_OPTIONS = [
  { id: 'line', label: 'Line', icon: '／' },
  { id: 'rectangle', label: 'Rectangle', icon: '▭' },
  { id: 'ellipse', label: 'Ellipse', icon: '○' },
];

function ShapeButton({ active, label, icon, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      title={label}
      style={{
        minHeight: 42,
        borderRadius: 6,
        border: active ? '1px solid rgba(180,215,255,0.66)' : '1px solid rgba(255,255,255,0.10)',
        background: active ? 'rgba(88,128,168,0.82)' : 'rgba(255,255,255,0.055)',
        color: 'rgba(245,247,250,0.96)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 7,
        padding: '0 9px',
        fontSize: 12,
        fontWeight: 850,
        cursor: 'pointer',
        boxShadow: active ? 'inset 0 0 0 1px rgba(255,255,255,0.12)' : 'none',
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 18, lineHeight: 1 }}>{icon}</span>
      <span>{label}</span>
    </button>
  );
}

export default function CanvasShapeSettingsPanel({ activeTool, setActiveTool }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: 6,
        minWidth: 0,
      }}
    >
      {SHAPE_OPTIONS.map((shape) => (
        <ShapeButton
          key={shape.id}
          active={activeTool === shape.id}
          label={shape.label}
          icon={shape.icon}
          onClick={() => {
            if (typeof setActiveTool === 'function') setActiveTool(shape.id);
          }}
        />
      ))}
    </div>
  );
}
